const API_BASE = import.meta.env.VITE_API_BASE || '/api'

export async function apiGet(endpoint) {
  const res = await fetch(`${API_BASE}${endpoint}`)
  if (!res.ok) {
    const text = await res.text()
    throw new Error(`${res.status}: ${text}`)
  }
  return res.json()
}

export async function apiPost(endpoint, body) {
  const res = await fetch(`${API_BASE}${endpoint}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  if (!res.ok) {
    const text = await res.text()
    throw new Error(`${res.status}: ${text}`)
  }
  return res.json()
}

export const getBio = () => apiGet('/bio/')
export const getExperience = () => apiGet('/experience/')
export const getEducation = () => apiGet('/education/')
export const getProjects = (params = {}) => {
  const qs = new URLSearchParams(params).toString()
  return apiGet(`/projects/${qs ? '?' + qs : ''}`)
}
export const getProject = (slug) => apiGet(`/projects/${encodeURIComponent(slug)}/`)
export const getBlogList = () => apiGet('/blog/')
export const getBlogPost = (slug) => apiGet(`/blog/${encodeURIComponent(slug)}/`)
export const getSkills = () => apiGet('/skills/')
export const getStats = () => apiGet('/stats/')
export const sendContact = (body) => apiPost('/contact/', body)
export const sendChat = (body) => apiPost('/agent/', body)

export async function* sendChatStream(body) {
  const res = await fetch(`${API_BASE}/agent/stream/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })

  if (!res.ok) {
    const text = await res.text()
    throw new Error(`${res.status}: ${text}`)
  }

  const reader = res.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''

  while (true) {
    const { done, value } = await reader.read()
    if (done) {
      buffer += decoder.decode()
      if (buffer.trim()) {
        const lines = buffer.split('\n')
        for (const line of lines) {
          const trimmed = line.trim()
          if (trimmed.startsWith('data: ')) {
            const data = trimmed.slice(6)
            if (data === '[DONE]') {
              yield { done: true }
              return
            }
            if (data === '[ERROR]') {
              yield { error: true }
              continue
            }
            try {
              yield JSON.parse(data)
            } catch {
              // skip unparseable lines
            }
          }
        }
      }
      break
    }

    buffer += decoder.decode(value, { stream: true })
    const lines = buffer.split('\n')
    buffer = lines.pop() || ''

    for (const line of lines) {
      const trimmed = line.trim()
      if (trimmed.startsWith('data: ')) {
        const data = trimmed.slice(6)
        if (data === '[DONE]') {
          yield { done: true }
          return
        }
        if (data === '[ERROR]') {
          yield { error: true }
          continue
        }
        try {
          yield JSON.parse(data)
        } catch {
          // skip unparseable lines
        }
      }
    }
  }
}
export const sendFeedback = (body) => apiPost('/agent/feedback/', body)
export const recordConsent = (body) => apiPost('/consent/', body)
export const checkConsent = (sessionId) => apiGet(`/consent/${encodeURIComponent(sessionId)}/`)
